import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Spin, Table, Button, Card } from 'antd';
import { Link, Route, Switch } from 'react-router-dom';

import AssociateConcernForm from '../../forms/AssociateConcernForm';
import AssociateConcernLayout from '../../layouts/AssociateConcernLayout';

import ALL_QUERY from '../../graphql/queries/getCustomerAssociateConcernsQuery.graphql';

const { Column } = Table;

const AssociateConcerns = (props) => {
  const { loading, associateConcerns } = props.data;
  if (loading) {
    return (
      <Spin size="large" />
    );
  }
  return (
    <Switch>
      <Route
        exact
        path={props.match.path}
        render={() => (
          <div>
            <h2 className="page-title">Factsheet - Associate Concerns</h2>
            <Card title="View all associate concerns" bordered={false} className="ec-card">
              <Table dataSource={associateConcerns} rowKey="id">
                <Column
                  title="Name"
                  dataIndex="name"
                  key="name"
                />
                <Column
                  title="Actions"
                  key="actions"
                  render={(text, record) => (
                    <div>
                      <Link to={`${props.match.url}/${record.id}/management`}>
                        <Button>Management Details</Button>
                      </Link>
                      <Link to={`${props.match.url}/${record.id}/company`}>
                        <Button>Company Background</Button>
                      </Link>
                      <Link to={`${props.match.url}/${record.id}/debt`}>
                        <Button>Debt Position</Button>
                      </Link>
                      <Link to={`${props.match.url}/${record.id}/financials`}>
                        <Button>Brief Financials</Button>
                      </Link>
                    </div>
                  )}
                />
              </Table>
            </Card>
            <Card title="Add new Associate Concern" bordered={false} className="ec-card">
              <AssociateConcernForm customer_id={props.match.params.id} />
            </Card>
          </div>
        )}
      />
      <Route path={`${props.match.path}/:cac_id`} render={(routeProps) => (<AssociateConcernLayout {...routeProps} associateConcerns={associateConcerns} />)} />
    </Switch>
  );
};

AssociateConcerns.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    associateConcerns: PropTypes.array,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      ac_id: PropTypes.string,
    }),
  }).isRequired,
};

export default graphql(ALL_QUERY, {
  options: ({ match }) => ({ variables: { customer_id: match.params.id } }),
})(AssociateConcerns);



// WEBPACK FOOTER //
// ./src/pages/factsheet/AssociateConcerns.jsx